import React, { Component } from "react";
import styles from "./Layouts/Layouts.local.scss";
import classnames from "classnames";

class FetchingEmbeddedContent extends Component {
  render() {
    return (
      <div className={`row ${styles.layout}`}>
        <div className={`large-12 medium-12 small-12`}>
          <div className={`${styles.flex_container}`}>
            <div
              className={classnames(
                "large-12 medium-12 small-12",
                styles.flex_container,
                styles.align_container
              )}
            >
              <div className={`large-12 medium-12 small-12 `}>
                <div className={`${styles.flex_container}`}>
                  <div
                    className={classnames(
                      "large-4 medium-12 small-12",
                      styles.flex_container,
                      styles.align_container
                    )}
                  >
                    <div
                      className={classnames(
                        styles.component_container,
                        styles.container_m_height,
                        styles.gradiant
                      )}
                    />
                  </div>
                  <div
                    className={classnames(
                      "large-4 medium-12 small-12",
                      styles.flex_container,
                      styles.align_container
                    )}
                  >
                    <div
                      className={classnames(
                        styles.component_container,
                        styles.container_m_height,
                        styles.gradiant
                      )}
                    />
                  </div>
                  <div
                    className={classnames(
                      "large-4 medium-12 small-12",
                      styles.flex_container,
                      styles.align_container
                    )}
                  >
                    <div
                      className={classnames(
                        styles.component_container,
                        styles.container_m_height,
                        styles.flex_container,
                        styles.align_container,
                        styles.gradiant
                      )}
                    />
                  </div>
                  <div
                    className={classnames(
                      "large-12 medium-12 small-12",
                      styles.flex_container,
                      styles.align_container
                    )}
                  >
                    <div
                      className={classnames(
                        styles.component_container,
                        styles.container_l_height,
                        styles.flex_container,
                        styles.align_container,
                        styles.gradiant
                      )}
                    />
                  </div>
                  <div
                    className={classnames(
                      "large-6 medium-12 small-12",
                      styles.flex_container,
                      styles.align_container
                    )}
                  >
                    <div
                      className={classnames(
                        "large-4 medium-12 small-12",
                        styles.flex_container,
                        styles.align_container,
                        styles.gradiant
                      )}
                    />
                    <div
                      className={classnames(
                        "large-4 medium-12 small-12",
                        styles.flex_container,
                        styles.align_container,
                        styles.gradiant
                      )}
                    />
                    <div
                      className={classnames(
                        "large-4 medium-12 small-12",
                        styles.flex_container,
                        styles.align_container,
                        styles.gradiant
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className={classnames(
                "small-12",
                styles.flex_container,
                styles.align_container
              )}
            >
              <div
                className={classnames(
                  styles.component_container,
                  styles.component_height,
                  styles.gradiant
                )}
              />
            </div>
            <div
              className={classnames(
                "large-12 medium-12 small-12",
                styles.flex_container,
                styles.align_container
              )}
            >
              <div
                className={classnames(
                  "large-4 medium-12 small-12",
                  styles.flex_container,
                  styles.align_container
                )}
              >
                <div
                  className={classnames(
                    styles.component_container,
                    styles.container_l_height,
                    styles.gradiant
                  )}
                />
              </div>
              <div
                className={classnames(
                  "large-4 medium-12 small-12",
                  styles.flex_container,
                  styles.align_container
                )}
              >
                <div
                  className={classnames(
                    styles.component_container,
                    styles.container_l_height,
                    styles.gradiant
                  )}
                />
              </div>
              <div
                className={classnames(
                  "large-4 medium-12 small-12",
                  styles.flex_container,
                  styles.align_container
                )}
              >
                <div
                  className={classnames(
                    styles.component_container,
                    styles.container_l_height,
                    styles.gradiant
                  )}
                />
              </div>
            </div>
            <div
              className={classnames(
                "large-12 medium-12 small-12",
                styles.flex_container,
                styles.align_container
              )}
            >
              <div
                className={classnames(
                  "large-6 medium-12 small-12",
                  styles.flex_container,
                  styles.align_container
                )}
              >
                <div
                  className={classnames(
                    styles.component_container,
                    styles.container_l_height,
                    styles.gradiant
                  )}
                />
              </div>
              <div
                className={classnames(
                  "large-6 medium-12 small-12",
                  styles.flex_container,
                  styles.align_container
                )}
              >
                <div
                  className={classnames(
                    styles.component_container,
                    styles.container_l_height,
                    styles.gradiant
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default FetchingEmbeddedContent;



// WEBPACK FOOTER //
// ./src/components/Dashboard/FetchingEmbeddedContent.js